import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt, faCoffee } from '@fortawesome/free-solid-svg-icons'

library.add(faSignOutAlt, faCoffee)